import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SharedUiAssetsModule } from '@iq-central-front-end/shared/ui/assets';
import { SharedUiComponentsModule } from '../../../../libs/shared/ui/components/src/lib/shared-ui-components.module';
import { HttpClientModule } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { ShareModule } from '@iq-central-front-end/share';
import { ToastrService } from 'ngx-toastr';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  {
    path: '',
    loadChildren: () =>
      import('@iq-central-front-end/shared/auth').then(
        (module) => module.AuthModule
      ),
  },
];

@NgModule({
  declarations: [AppComponent, HomeComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes),
    SharedUiAssetsModule,
    SharedUiComponentsModule, //.forRoot(),
    HttpClientModule,
    JwtModule.forRoot({
      config: {},
    }),
    ShareModule,
  ],
  providers: [ToastrService],
  bootstrap: [AppComponent],
})
export class AppModule {}
